import React, { useContext, useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Store } from '../Store';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getError } from '../utils';
import { toast } from 'react-toastify';
import FloatingButton from '../component/FloatingButton';
import { api } from '../Api';
export default function UserPanelScreen() {
  const navigate = useNavigate();
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;
  const signoutHandler = () => {
    ctxDispatch({ type: 'USER_SIGNOUT' });
    localStorage.removeItem('userInfo');
    localStorage.removeItem('shippingAddress');
    localStorage.removeItem('paymentMethod');
    // localStorage.removeItem('token');
    // perform any other necessary cleanup or API calls
    window.location.reload();
    //  window.location.href = '/signin';
  };
  const [designation, setDesigntion] = useState('...');

  useEffect(() => {
    if (userInfo) {
      checkNotice();
      userInfo.designation === 0
        ? setDesigntion('Royal Customer')
        : getDesignation();
      checkDesignation();
    } else {
      window.location.href = '/signin';
    }
  }, [userInfo]);

  async function getDesignation() {
    try {
      const { data } = await axios.post(
        api + '/api/designation/getuserdesignation',
        { serial: userInfo.designation },
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        }
      );
      setDesigntion(data.name);
    } catch (error) {
      toast.error(getError(error));
    }
  }

  async function checkDesignation() {
    try {
      const data = await axios.post(
        api + '/api/users/getlivedata',
        { username: userInfo.username },
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        }
      );
    } catch (error) {
      toast.error(getError('CheckDesignation: ' + error));
    }
  }
  const [notice, setNotice] = useState(false);
  const [chat, setChat] = useState(0);
  async function checkNotice() {
    try {
      const { data } = await axios.post(
        api + '/api/users/checkNotice',
        { userInfo },
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        }
      );
      console.log('CheckNotice: ' + data);
      setNotice(data.data);
      setChat(data.chat);
    } catch (error) {
      toast.error(getError('checkNotice: ' + error));
    }
  }

  // Merchants get an extra tile for the withdraw requests routed to them.
  // `isAssociation` is not in the login payload, so it is read fresh from the
  // server. The topup settings call answers it whether or not topups are
  // switched on; if that call fails, /api/users/me (the whole user record) is
  // asked instead. The last answer is remembered per user, so one failed
  // request on a slow connection does not make the tile vanish.
  const merchantCacheKey = userInfo?.username ? `isMerchant:${userInfo.username}` : '';
  const [isMerchant, setIsMerchant] = useState(() => {
    if (userInfo?.isAssociation) return true;
    try {
      return Boolean(merchantCacheKey) && localStorage.getItem(merchantCacheKey) === '1';
    } catch (e) {
      return false;
    }
  });
  const [pendingWithdraws, setPendingWithdraws] = useState(0);
  useEffect(() => {
    if (!userInfo?.token) return undefined;
    let alive = true;
    const auth = { headers: { Authorization: `Bearer ${userInfo.token}` } };
    const remember = (flag) => {
      try {
        if (merchantCacheKey) localStorage.setItem(merchantCacheKey, flag ? '1' : '0');
      } catch (e) {
        /* storage blocked — the tile still follows this session's answer */
      }
    };
    (async () => {
      let flag = null;
      try {
        const { data } = await axios.get(api + '/api/topup/settings', auth);
        if (data?.me) flag = Boolean(data.me.isAssociation);
      } catch (error) {
        /* fall through to /me */
      }
      if (flag === null) {
        try {
          const { data } = await axios.get(api + '/api/users/me', auth);
          if (data && typeof data === 'object') flag = Boolean(data.isAssociation);
        } catch (error) {
          /* both failed — keep whatever was remembered */
        }
      }
      if (!alive || flag === null) return;
      setIsMerchant(flag);
      remember(flag);
      if (!flag) return;
      // The badge counts everything waiting on the merchant: routed
      // withdraws plus Request Money (the page shows both as tabs).
      const [wd, mr] = await Promise.allSettled([
        axios.get(api + '/api/association/withdraw/mine?status=pending&page=1&pageSize=1', auth),
        axios.get(api + '/api/money-requests/merchant?status=pending&page=1&pageSize=1', auth),
      ]);
      // The badge is a nicety — a failed count just leaves that part out.
      const count = (r) => (r.status === 'fulfilled' ? Number(r.value?.data?.count) || 0 : 0);
      if (alive) setPendingWithdraws(count(wd) + count(mr));
    })();
    return () => {
      alive = false;
    };
  }, [userInfo?.token, merchantCacheKey]);
  const tiles = isMerchant ? [...TILES, MERCHANT_WITHDRAW_TILE] : TILES;

  function update() {
    // Debug code removed - direct context mutation caused memory leak
  }
  return (
    <Container style={{ background: '#a8dcf4', height: '97.4vh' }}>
      <FloatingButton />
      <Row>
        <Col style={{ textAlign: 'center' }}>
          <img
            src="https://res.cloudinary.com/dddogyqqa/image/upload/v1670435815/logo/clickcart-logo_wfktlg.png"
            style={{ width: '15rem', margin: '2rem' }}
            alt="Logo"
          />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <Row style={{ marginTop: '0.5rem' }}>
            <Col>
              <img
                src={userInfo.profilePhoto}
                style={{
                  width: '100px',
                  border: '1px solid white',
                  borderRadius: '10px',
                  padding: '0px',
                }}
                alt={userInfo.username}
              />
              <div
                style={{
                  background: '#48b4e4',
                  width: '70%',
                  float: 'right',
                  padding: '0.45rem',
                  color: 'white',
                  borderRadius: '10px',
                }}
              >
                <h2 style={{ margin: '0px', fontWeight: '700' }}>
                  {userInfo.name}{' '}
                </h2>
                @username: {userInfo.username}
                <br></br>Designation : {designation}
              </div>
            </Col>
          </Row>
          <Row
            style={{
              background: '#68d4f4',
              padding: '0.3rem',
              margin: '2rem',
            }}
          >
            <Col>
              <Link to="/settings" style={{ color: 'white' }}>
                <i className="fa fa-cog" aria-hidden="true"></i>
              </Link>
            </Col>
            <Col>
              <Link to="/notification" style={{ color: 'white' }}>
                {notice === 0 ? (
                  <i
                    className="fa fa-bell"
                    style={{ color: 'red' }}
                    aria-hidden="true"
                  ></i>
                ) : (
                  <i className="fa fa-bell  " aria-hidden="true"></i>
                )}
              </Link>
            </Col>
            <Col>
              <Link style={{ color: 'white' }} to="/chat">
                {chat === 0 ? (
                  <i className="fa fa-comments" aria-hidden="true"></i>
                ) : (
                  <i
                    className="fa fa-comments  "
                    style={{ color: 'red' }}
                    aria-hidden="true"
                  ></i>
                )}
              </Link>
            </Col>
            <Col>
              <Link
                to="#signout"
                onClick={signoutHandler}
                style={{ color: 'white' }}
              >
                <i className="fa fa-sign-out" aria-hidden="true"></i>
              </Link>
            </Col>
          </Row>
        </Col>
        <Col sm={6} style={{ marginTop: '0.5rem' }}>
          {/* Two tiles per row on every width, all the same height. */}
          <style>{TILE_CSS}</style>
          <Row className="g-2 up-tiles">
            {tiles.map((tile) => (
              <Col xs={6} key={tile.to}>
                <Link to={tile.to} className="up-tile">
                  <i className={`fa ${tile.icon}`} aria-hidden="true"></i>
                  <span>{tile.label}</span>
                  {tile.badge && pendingWithdraws > 0 ? (
                    <span className="up-tile-badge">{pendingWithdraws > 99 ? '99+' : pendingWithdraws}</span>
                  ) : null}
                </Link>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

/* The member's shortcuts. Order matters: money in, money around, money out. */
const TILES = [
  { to: '/treeview', icon: 'fa-link', label: 'Team Maintenance' },
  { to: '/transection', icon: 'fa-credit-card-alt', label: 'Transaction' },
  { to: '/transferandhistory', icon: 'fa-exchange', label: 'Transfer & History' },
  { to: '/shop', icon: 'fa-cart-plus', label: 'Shop' },
  { to: '/salesandpromotion', icon: 'fa-gift', label: 'Sales man Promotion' },
  { to: '/withdraw', icon: 'fa-credit-card', label: 'Withdraw' },
  { to: '/sales', icon: 'fa-balance-scale', label: 'Sales' },
  { to: '/topup', icon: 'fa-plus-circle', label: 'Topup Balance' },
  // Ask a merchant above you for Shopping Balance after paying them offline.
  { to: '/request-money', icon: 'fa-hand-o-up', label: 'Request Money' },
];

/* Merchants only — shown after the topup settings call confirms the flag. */
const MERCHANT_WITHDRAW_TILE = {
  to: '/merchant/withdraw-requests',
  icon: 'fa-money',
  label: 'Withdraw Requests',
  badge: true,
};

const TILE_CSS = `
.up-tiles { margin-bottom: 1rem; }
.up-tile {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 6px; height: 100%; min-height: 84px; padding: 12px 8px; text-align: center;
  background: #48b4e4; color: #fff; border-radius: 12px; font-size: 0.95rem;
  font-weight: 600; line-height: 1.2; text-decoration: none;
  box-shadow: 0 1px 3px rgba(0,0,0,.15); transition: background .15s, transform .15s;
}
.up-tile:hover, .up-tile:focus { background: #2f9fd1; color: #fff; transform: translateY(-1px); }
.up-tile i { font-size: 1.35rem; }
.up-tile { position: relative; }
.up-tile-badge { position: absolute; top: 6px; right: 8px; min-width: 20px; height: 20px;
  padding: 0 6px; border-radius: 999px; background: #ef4444; color: #fff; font-size: 11px;
  font-weight: 800; line-height: 20px; }
@media (max-width: 400px) { .up-tile { min-height: 76px; font-size: .85rem; } }
`;
